export default ".headerLanguagelabel {\n    position: absolute;\n}";